module.exports = __webpack_public_path__ + "media/images/menu/mercury-a4eb7c7ff6cc2bd069a0110e7c355942.jpg";